<template>
<!--  <fb-list-body :showPager="false" :showBtnGroup="false" :showSearchForm="false">
    <template slot="table">
      <el-tabs v-model="activeName">
        <el-tab-pane :label="`收藏的菜谱（${countData.collectCount || 0}）`" name="collect">
          <recipe-record-list type="collect">
            <el-table-column align="center" label="收藏时间" prop="collectTimeStr" />
          </recipe-record-list>
        </el-tab-pane>
        <el-tab-pane :label="`使用的菜谱（${countData.useCount || 0}）`" name="use">
          <recipe-record-list type="use">
            <el-table-column align="center" label="制作时间" prop="useTimeStr" />
          </recipe-record-list>
        </el-tab-pane>
        <el-tab-pane :label="`购买的菜谱（${countData.payCount || 0}）`" name="buy">
          <recipe-record-list type="pay">
            <el-table-column align="center" label="支付金额" prop="payPrice" />
            <el-table-column align="center" label="支付时间" prop="payTimeStr" />
          </recipe-record-list>
        </el-tab-pane>
        <el-tab-pane :label="`打赏的菜谱（${countData.rewardCount || 0}）`" name="award">
          <recipe-record-list type="reward">
            <el-table-column align="center" label="打赏金额" prop="rewardPrice" />
            <el-table-column align="center" label="支付时间" prop="rewardTimeStr" />
          </recipe-record-list>
        </el-tab-pane>
        <el-tab-pane :label="`评级的菜谱（${countData.evaluateCount || 0}）`" name="comment">
          <recipe-record-list type="evaluate">
            <el-table-column align="center" label="评分" prop="star" />
            <el-table-column align="center" label="评价时间" prop="evaluateTimeStr" />
          </recipe-record-list>
        </el-tab-pane>
        <el-tab-pane :label="`浏览的菜谱（${countData.watchCount || 0}）`" name="read">
          <recipe-record-list type="watch">
            <el-table-column align="center" label="浏览时间" prop="watchTimeStr" />
          </recipe-record-list>
        </el-tab-pane>
      </el-tabs>
    </template>
  </fb-list-body>-->

  <ankh-list :showBtnGroup="false" :showSearchForm="false">
    <template #tab-row>
      <el-tabs v-model="activeName">
        <el-tab-pane
            v-for="item in comps"
            :key="item.name"
            :label="`${$t(item.label)}（${item.count}）`"
            :name="item.type" />
      </el-tabs>
    </template>
    <template #table="{height}">
      <recipe-record-list
          :height="height"
          :type="activeItem.type"
          :tab-current="activeItem.type"
          :current="activeName"
          :column-list="activeItem.columnList" />
    </template>
  </ankh-list>
</template>

<script>
import RecipeRecordList from "@/components/user/RecipeRecordList";
import {request} from "@/config/request";
import AnkhList from "@/components/list/AnkhList.vue";
export default {
  name: "UserRecipeRecord",
  components: {AnkhList, RecipeRecordList},
  data() {
    return {
      activeName: "collect",
      comps: [
        {
          name: "collectCount",
          label: "收藏的菜谱",
          count: 0,
          type: "collect",
          columnList: [
            {label: "收藏时间", prop: "collectTimeStr"},
          ]
        },
        {
          name: "useCount",
          label: "使用的菜谱",
          count: 0,
          type: "use",
          columnList: [
            {label: "制作时间", prop: "useTimeStr"},
          ]
        },
        {
          name: "payCount",
          label: "购买的菜谱",
          count: 0,
          type: "pay",
          columnList: [
            {label: "支付金额", prop: "payPrice"},
            {label: "支付时间", prop: "payTimeStr"},
          ]
        },
        {
          name: "rewardCount",
          label: "打赏的菜谱",
          count: 0,
          type: "reward",
          columnList: [
            {label: "打赏金额", prop: "rewardPrice"},
            {label: "支付时间", prop: "rewardTimeStr"},
          ]
        },
        {
          name: "evaluateCount",
          label: "评价的菜谱",
          count: 0,
          type: "evaluate",
          columnList: [
            {label: "评分", prop: "star"},
            {label: "评价时间", prop: "evaluateTimeStr"},
          ]
        },
        {
          name: "watchCount",
          label: "浏览的菜谱",
          count: 0,
          type: "watch",
          columnList: [
            {label: "浏览时间", prop: "watchTimeStr"},
          ]
        },
      ],
      countData: {}
    }
  },
  created() {
    this.loadUserRecipeRecordCount();
  },
  methods: {
    // 加载用户菜谱统计数量
    async loadUserRecipeRecordCount() {
      try {
        const res = await request(this.$api.cookbook.countData, {userNum: this.$route.query.num});
        const countData = res.countMap;
        this.comps.forEach(item => {
          item.count = countData[item.name] || 0;
        })
      } catch (e) {
        console.log(e);
      }
    }
  },
  computed: {
    activeItem() {
      return this.comps.find(item => item.type === this.activeName)
    }
  }
}
</script>

<style scoped>

</style>
